/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import * as types from '../types'

export const success = (message) => {
  return { type: types.alert.SUCCESS, message }
}

export const error = (message) => {
  return { type: types.alert.ERROR, message }
}

export const clear = () => {
  return { type: types.alert.CLEAR }
}
